"use client"
import ProductModalOutOfStock from "@/app/products/[...handle]/_components/productDetail/_components/productModalOutOfStock/ProductModalOutOfStock";
import { ProductJson } from "@/types/Product.type";
import React from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { setProductSendMail } from "@/redux/features/ShopSlice";
import PopupV2 from "@/components/PopupV2";

export default function PopupSendMail() {
  const dispatch = useAppDispatch()
  const device = useAppSelector(state=>state.ShopReducer.device)
  const product = useAppSelector(state => state.ShopReducer.productSendMail)
  function setIsOpenModalProductOut(product: ProductJson | null) {
    dispatch(setProductSendMail(product))
  }
  return (
    <PopupV2
      onOpenChange={() => setIsOpenModalProductOut(null)}
      open={!!product}
      classNameContent="border border-gray-200 bg-white shadow md:rounded md:h-auto
      w-screen h-[320px]  md:w-[460px] "
      animate={device === "desktop" ? "fade"  : "tran-up"}
      isDrawerMobile={false}
    >
      {product && <ProductModalOutOfStock product_variant={product} />}
    </PopupV2>
  )
}
